import React from 'react';
import { useNavigate } from 'react-router-dom';

/* Нижняя навигация «← предыдущий / следующий →» по упорядоченному списку id.
   ids — массив id по порядку; makePath(id) — куда вести; fromPath — для кнопки «Назад». */
const IcLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
);
const IcRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
);

export default function LessonPager({ ids, currentId, makePath, fromPath, prevLabel = 'Предыдущий', nextLabel = 'Следующий' }) {
  const navigate = useNavigate();
  if (!ids || ids.length < 2) return null;
  const idx = ids.indexOf(Number(currentId));
  if (idx < 0) return null;
  const prevId = idx > 0 ? ids[idx - 1] : null;
  const nextId = idx < ids.length - 1 ? ids[idx + 1] : null;

  const btn = (disabled) => ({
    display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 18px', borderRadius: 11,
    border: '1px solid var(--border)', background: 'var(--card)',
    color: disabled ? 'var(--text-3)' : 'var(--text-1)', fontSize: 13, fontWeight: 600,
    cursor: disabled ? 'default' : 'pointer', fontFamily: 'inherit', opacity: disabled ? 0.45 : 1,
  });
  const go = (id) => { if (id) navigate(makePath(id), { state: { from: fromPath } }); };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, maxWidth: 880, margin: '22px auto 4px' }}>
      <button style={btn(!prevId)} disabled={!prevId} onClick={() => go(prevId)}>
        <IcLeft /> {prevLabel}
      </button>
      <button style={btn(!nextId)} disabled={!nextId} onClick={() => go(nextId)}>
        {nextLabel} <IcRight />
      </button>
    </div>
  );
}
